"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFileUpload = exports.useDeleteBulk = exports.useDelete = exports.useUpdateBulk = exports.useUpdate = exports.useEdit = exports.useSetHeader = exports.usePrepend = exports.useCreate = exports.useLoad = exports.useSearch = exports.useReset = void 0;
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_i18next_1 = require("react-i18next");
var lodash_1 = require("lodash");
var util_1 = require("remota-common/util");
var object_1 = require("remota-client/util/object");
var multi_1 = require("remota-client/module/multi");
var loading_1 = require("./loading");
var notification_1 = require("./notification");
var action_1 = require("../module/multi/action");
var buildMessage = function (t, key, message) {
    var base = t(key);
    if (!message) {
        return base;
    }
    var mes = t(message);
    return "".concat(base, " - ").concat(mes);
};
/**
 * リセットを仕様する。
 * 型パラメータは Module
 */
var useReset = function (module) {
    var dispatch = (0, react_redux_1.useDispatch)();
    return (0, react_1.useCallback)(function () {
        dispatch((0, multi_1.reset)(module));
    }, [module, dispatch]);
};
exports.useReset = useReset;
/**
 * 検索を使用する。
 * 型パラメータは Module, Header, Query, Item
 */
var useSearch = function (module, state, url, query, option) {
    var _a = option || {}, _b = _a.searchOnLoad, searchOnLoad = _b === void 0 ? true : _b, _c = _a.notifyOnSuccess, notifyOnSuccess = _c === void 0 ? false : _c, _d = _a.notificationSuccessKey, notificationSuccessKey = _d === void 0 ? "".concat(module, ".search.success") : _d, _e = _a.notifyOnFailure, notifyOnFailure = _e === void 0 ? true : _e, _f = _a.notificationFailureKey, notificationFailureKey = _f === void 0 ? "".concat(module, ".search.failure") : _f;
    var _g = __read((0, react_1.useState)(searchOnLoad), 2), isStarted = _g[0], setStarted = _g[1];
    var queryHash = (0, react_1.useMemo)(function () { return (0, object_1.getHash)([url, (0, lodash_1.omit)(query, "cursor")]); }, [url, query]);
    var _h = __read((0, react_i18next_1.useTranslation)(), 1), t = _h[0];
    var notify = (0, notification_1.useNotify)();
    var resultToAction = (0, react_1.useCallback)(function (res) {
        if (notifyOnSuccess) {
            notify({ message: buildMessage(t, notificationSuccessKey), severity: "success" });
        }
        setStarted(false);
        return (0, multi_1.setResult)(module, queryHash, res);
    }, [module, notificationSuccessKey, notify, notifyOnSuccess, queryHash, t]);
    var errorToAction = (0, react_1.useCallback)(function (e) {
        if (notifyOnFailure) {
            notify({ message: buildMessage(t, notificationFailureKey, e.message), severity: "error" });
        }
        return undefined;
    }, [notificationFailureKey, notify, notifyOnFailure, t]);
    var _j = __read(getItems(state[0], queryHash), 2), items = _j[0], count = _j[1];
    var isInitialized = state[0].isInitializedMap[queryHash] || false;
    var nextCursor = state[0].cursorMap[queryHash];
    (0, react_1.useEffect)(function () {
        // query が変わった場合などに初期読み込みできるようにする
        if (!isStarted && searchOnLoad && nextCursor === undefined) {
            setStarted(true);
        }
    }, [isStarted, nextCursor, searchOnLoad]);
    var loadingStatus = (0, loading_1.useHttpGet)(state[1], url, (0, util_1.omitUndefined)(__assign(__assign({}, query), { cursor: nextCursor, t: state[0].resetAt })), isStarted && nextCursor !== null, resultToAction, errorToAction);
    var canSearchMore = isInitialized && !loadingStatus.isLoading && state[0].cursorMap[queryHash] !== null;
    var searchStatus = (0, react_1.useMemo)(function () { return (__assign(__assign({}, loadingStatus), { isInitialized: isInitialized, canSearchMore: canSearchMore })); }, [canSearchMore, isInitialized, loadingStatus]);
    var run = (0, react_1.useCallback)(function () {
        setStarted(true);
    }, [setStarted]);
    return (0, react_1.useMemo)(function () { return [items, count, searchStatus, run]; }, [count, items, run, searchStatus]);
};
exports.useSearch = useSearch;
function getItems(state, queryHash) {
    var ids = state.idsMap[queryHash];
    var count = state.countMap[queryHash];
    var newItems = state.newItems;
    if (!ids) {
        if (newItems.length === 0) {
            return [undefined, count];
        }
        else {
            return [newItems, count];
        }
    }
    var items = ids.map(function (id) { return state.headerMap[id]; });
    return [(0, lodash_1.uniqBy)(items.concat(newItems), function (item) { return item.id; }), count];
}
/**
 * 単体読み込みを使用する。
 * 型パラメータは Module, Header, Item
 */
var useLoad = function (module, state, url, id, option) {
    var _a = option || {}, _b = _a.notifyOnSuccess, notifyOnSuccess = _b === void 0 ? false : _b, _c = _a.notificationSuccessKey, notificationSuccessKey = _c === void 0 ? "".concat(module, ".load.success") : _c, _d = _a.notifyOnFailure, notifyOnFailure = _d === void 0 ? true : _d, _e = _a.notificationFailureKey, notificationFailureKey = _e === void 0 ? "".concat(module, ".load.failure") : _e;
    var _f = __read((0, react_i18next_1.useTranslation)(), 1), t = _f[0];
    var notify = (0, notification_1.useNotify)();
    var resultToAction = (0, react_1.useCallback)(function (res) {
        if (notifyOnSuccess) {
            notify({ message: buildMessage(t, notificationSuccessKey), severity: "success" });
        }
        return (0, multi_1.setItems)(module, [res]);
    }, [module, notificationSuccessKey, notify, notifyOnSuccess, t]);
    var errorToAction = (0, react_1.useCallback)(function (e) {
        if (notifyOnFailure) {
            notify({ message: buildMessage(t, notificationFailureKey, e.message), severity: "error" });
        }
        return undefined;
    }, [notificationFailureKey, notify, notifyOnFailure, t]);
    var item = state[0].itemMap[id];
    if (!id)
        url = "INVALID";
    var status = (0, loading_1.useHttpGet)(state[1], url, (0, util_1.omitUndefined)({ t: state[0].resetAt }), item === undefined, resultToAction, errorToAction);
    return (0, react_1.useMemo)(function () { return [item || state[0].headerMap[id], status]; }, [id, item, state, status]);
};
exports.useLoad = useLoad;
/**
 * 作成を使用する。
 * 型パラメータは Module, Header, Item, Body
 */
var useCreate = function (module, state, url, option) {
    var _a = option || {}, _b = _a.notifyOnSuccess, notifyOnSuccess = _b === void 0 ? true : _b, _c = _a.notificationSuccessKey, notificationSuccessKey = _c === void 0 ? "".concat(module, ".create.success") : _c, _d = _a.notifyOnFailure, notifyOnFailure = _d === void 0 ? true : _d, _e = _a.notificationFailureKey, notificationFailureKey = _e === void 0 ? "".concat(module, ".create.failure") : _e;
    var _f = __read((0, react_i18next_1.useTranslation)(), 1), t = _f[0];
    var notify = (0, notification_1.useNotify)();
    var resultToAction = (0, react_1.useCallback)(function (res) {
        if (notifyOnSuccess) {
            notify({ message: buildMessage(t, notificationSuccessKey), severity: "success" });
        }
        return (0, multi_1.addItem)(module, res);
    }, [module, notificationSuccessKey, notify, notifyOnSuccess, t]);
    var errorToAction = (0, react_1.useCallback)(function (e) {
        if (notifyOnFailure) {
            notify({ message: buildMessage(t, notificationFailureKey, e.message), severity: "error" });
        }
        return undefined;
    }, [notificationFailureKey, notify, notifyOnFailure, t]);
    var _g = __read((0, loading_1.useHttpPostBody)(state[1], url, resultToAction, errorToAction), 2), run = _g[0], status = _g[1];
    var newItems = state[0].newItems;
    var newItem = newItems.length === 0 ? undefined : newItems[newItems.length - 1];
    return (0, react_1.useMemo)(function () { return [run, status, newItem]; }, [newItem, run, status]);
};
exports.useCreate = useCreate;
var usePrepend = function (module) {
    var dispatch = (0, react_redux_1.useDispatch)();
    var prepend = (0, react_1.useCallback)(function (item, queryHash) {
        dispatch((0, action_1.prependItem)(module, item, queryHash));
    }, [module, dispatch]);
    return prepend;
};
exports.usePrepend = usePrepend;
var useSetHeader = function (module) {
    var dispatch = (0, react_redux_1.useDispatch)();
    var setHeader = (0, react_1.useCallback)(function (item) {
        dispatch((0, action_1.setHeaderItems)(module, [item]));
    }, [module, dispatch]);
    return setHeader;
};
exports.useSetHeader = useSetHeader;
/**
 * 編集を使用する。
 * 型パラメータは Module, Header, Item
 */
var useEdit = function (module) {
    var dispatch = (0, react_redux_1.useDispatch)();
    var edit = (0, react_1.useCallback)(function (item) {
        dispatch((0, multi_1.setItems)(module, [item]));
    }, [module, dispatch]);
    return edit;
};
exports.useEdit = useEdit;
/**
 * 更新を使用する。
 * 型パラメータは Module, Header, Item, Body
 */
var useUpdate = function (module, state, url, option) {
    var _a = option || {}, _b = _a.notifyOnSuccess, notifyOnSuccess = _b === void 0 ? true : _b, _c = _a.notificationSuccessKey, notificationSuccessKey = _c === void 0 ? "".concat(module, ".update.success") : _c, _d = _a.notifyOnFailure, notifyOnFailure = _d === void 0 ? true : _d, _e = _a.notificationFailureKey, notificationFailureKey = _e === void 0 ? "".concat(module, ".update.failure") : _e, onSuccess = _a.onSuccess;
    var _f = __read((0, react_i18next_1.useTranslation)(), 1), t = _f[0];
    var notify = (0, notification_1.useNotify)();
    var resultToAction = (0, react_1.useCallback)(function (res, req) {
        if (notifyOnSuccess) {
            notify({ message: buildMessage(t, notificationSuccessKey), severity: "success" });
        }
        if (onSuccess) {
            onSuccess(res, req);
        }
        return (0, multi_1.setItems)(module, [res]);
    }, [module, notificationSuccessKey, notify, notifyOnSuccess, onSuccess, t]);
    var errorToAction = (0, react_1.useCallback)(function (e) {
        if (notifyOnFailure) {
            notify({ message: buildMessage(t, notificationFailureKey, e.message), severity: "error" });
        }
        return undefined;
    }, [notificationFailureKey, notify, notifyOnFailure, t]);
    return (0, loading_1.useHttpPutBody)(state, url, resultToAction, errorToAction);
};
exports.useUpdate = useUpdate;
/**
 * 一括更新を使用する。
 * 型パラメータは Module, Header, Item, Body
 */
var useUpdateBulk = function (module, state, url, option) {
    var _a = option || {}, _b = _a.notifyOnSuccess, notifyOnSuccess = _b === void 0 ? true : _b, _c = _a.notificationSuccessKey, notificationSuccessKey = _c === void 0 ? "".concat(module, ".updateBulk.success") : _c, _d = _a.notifyOnFailure, notifyOnFailure = _d === void 0 ? true : _d, _e = _a.notificationFailureKey, notificationFailureKey = _e === void 0 ? "".concat(module, ".updateBulk.failure") : _e, onSuccess = _a.onSuccess;
    var _f = __read((0, react_i18next_1.useTranslation)(), 1), t = _f[0];
    var notify = (0, notification_1.useNotify)();
    var resultToAction = (0, react_1.useCallback)(function (res, req) {
        if (notifyOnSuccess) {
            notify({ message: buildMessage(t, notificationSuccessKey), severity: "success" });
        }
        if (onSuccess) {
            onSuccess(res, req);
        }
        return (0, multi_1.setItems)(module, res);
    }, [module, notificationSuccessKey, notify, notifyOnSuccess, t]);
    var errorToAction = (0, react_1.useCallback)(function (e) {
        if (notifyOnFailure) {
            notify({ message: buildMessage(t, notificationFailureKey, e.message), severity: "error" });
        }
        return undefined;
    }, [notificationFailureKey, notify, notifyOnFailure, t]);
    return (0, loading_1.useHttpPutBody)(state, url, resultToAction, errorToAction);
};
exports.useUpdateBulk = useUpdateBulk;
/**
 * 削除を使用する。
 * 型パラメータは Module
 */
var useDelete = function (module, state, url, id, option) {
    var _a = option || {}, _b = _a.notifyOnSuccess, notifyOnSuccess = _b === void 0 ? true : _b, _c = _a.notificationSuccessKey, notificationSuccessKey = _c === void 0 ? "".concat(module, ".delete.success") : _c, _d = _a.notifyOnFailure, notifyOnFailure = _d === void 0 ? true : _d, _e = _a.notificationFailureKey, notificationFailureKey = _e === void 0 ? "".concat(module, ".delete.failure") : _e;
    var _f = __read((0, react_1.useState)(false), 2), running = _f[0], setRunning = _f[1];
    var _g = __read((0, react_i18next_1.useTranslation)(), 1), t = _g[0];
    var notify = (0, notification_1.useNotify)();
    var resultToAction = (0, react_1.useCallback)(function () {
        if (notifyOnSuccess) {
            notify({ message: buildMessage(t, notificationSuccessKey), severity: "success" });
        }
        setRunning(false);
        return (0, multi_1.deleteItems)(module, [id]);
    }, [notifyOnSuccess, module, id, notify, t, notificationSuccessKey]);
    var errorToAction = (0, react_1.useCallback)(function (e) {
        if (notifyOnFailure) {
            notify({ message: buildMessage(t, notificationFailureKey, e.message), severity: "error" });
        }
        return undefined;
    }, [notificationFailureKey, notify, notifyOnFailure, t]);
    var status = (0, loading_1.useHttpDelete)(state, url, running, resultToAction, errorToAction);
    var run = (0, react_1.useCallback)(function () {
        setRunning(true);
    }, [setRunning]);
    return (0, react_1.useMemo)(function () { return [run, status]; }, [run, status]);
};
exports.useDelete = useDelete;
/**
 * 削除を使用する。
 * 型パラメータは Module
 */
var useDeleteBulk = function (module, state, url, option) {
    var _a = option || {}, _b = _a.notifyOnSuccess, notifyOnSuccess = _b === void 0 ? true : _b, _c = _a.notificationSuccessKey, notificationSuccessKey = _c === void 0 ? "".concat(module, ".deleteBulk.success") : _c, _d = _a.notifyOnFailure, notifyOnFailure = _d === void 0 ? true : _d, _e = _a.notificationFailureKey, notificationFailureKey = _e === void 0 ? "".concat(module, ".deleteBulk.failure") : _e;
    var _f = __read((0, react_1.useState)([]), 2), ids = _f[0], setIds = _f[1];
    var _g = __read((0, react_i18next_1.useTranslation)(), 1), t = _g[0];
    var notify = (0, notification_1.useNotify)();
    var resultToAction = (0, react_1.useCallback)(function () {
        if (notifyOnSuccess) {
            notify({ message: buildMessage(t, notificationSuccessKey), severity: "success" });
        }
        setIds([]);
        return (0, multi_1.deleteItems)(module, ids);
    }, [notifyOnSuccess, module, ids, notify, t, notificationSuccessKey]);
    var errorToAction = (0, react_1.useCallback)(function (e) {
        if (notifyOnFailure) {
            notify({ message: buildMessage(t, notificationFailureKey, e.message), severity: "error" });
        }
        return undefined;
    }, [notificationFailureKey, notify, notifyOnFailure, t]);
    var status = (0, loading_1.useHttpPost)(state, url, ids, ids.length > 0, resultToAction, errorToAction);
    var run = (0, react_1.useCallback)(function (ids) {
        setIds(ids);
    }, [setIds]);
    return (0, react_1.useMemo)(function () { return [run, status]; }, [run, status]);
};
exports.useDeleteBulk = useDeleteBulk;
var useFileUpload = function (module, state, url, option) {
    var _a = option || {}, _b = _a.notifyOnSuccess, notifyOnSuccess = _b === void 0 ? true : _b, _c = _a.notificationSuccessKey, notificationSuccessKey = _c === void 0 ? "".concat(module, ".fileUpload.success") : _c, _d = _a.notifyOnFailure, notifyOnFailure = _d === void 0 ? true : _d, _e = _a.notificationFailureKey, notificationFailureKey = _e === void 0 ? "".concat(module, ".fileUpload.failure") : _e;
    var _f = __read((0, react_1.useState)(null), 2), file = _f[0], setFile = _f[1];
    var _g = __read((0, react_i18next_1.useTranslation)(), 1), t = _g[0];
    var notify = (0, notification_1.useNotify)();
    var resultToAction = (0, react_1.useCallback)(function () {
        if (notifyOnSuccess) {
            notify({ message: buildMessage(t, notificationSuccessKey), severity: "success" });
        }
        setFile(null);
    }, [notifyOnSuccess, notify, t, notificationSuccessKey]);
    var errorToAction = (0, react_1.useCallback)(function (e) {
        if (notifyOnFailure) {
            notify({ message: buildMessage(t, notificationFailureKey, e.message), severity: "error" });
        }
        return undefined;
    }, [notificationFailureKey, notify, notifyOnFailure, t]);
    var form = (0, react_1.useMemo)(function () {
        if (!file) {
            return null;
        }
        var form = new FormData();
        form.append("file", file);
        return form;
    }, [file]);
    var status = (0, loading_1.useHttpPostForm)(state, url, form, form !== null, resultToAction, errorToAction);
    var run = (0, react_1.useCallback)(function (file) {
        setFile(file);
    }, [setFile]);
    return (0, react_1.useMemo)(function () { return [run, status]; }, [run, status]);
};
exports.useFileUpload = useFileUpload;
